import { IconProps } from './IconProps';

export const TickWhite = (props: IconProps) => {
  return (
    <svg
      width="13px"
      height="10px"
      viewBox="0 0 13 10"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      style={props.style}
    >
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="section-/-after-payment"
          transform="translate(-314.000000, -852.000000)"
          stroke={props.fill ?? '#FFFFFF'}
          strokeWidth="2"
        >
          <g
            id="section-/-footbar-/-PreOrder-Copy"
            transform="translate(0.000000, 826.000000)"
          >
            <g id="Group" transform="translate(315.000000, 27.000000)">
              <polyline
                id="Path"
                points="10.6666667 0 3.33333333 7.33333333 0 4"
              ></polyline>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

